import type { DocumentChangeAuditRepository } from "../../repositories/DocumentChangeAuditRepository";
import type {
  DocumentChangeAuditQueryParams,
  DocumentChangeReportSummaryEntity,
} from "../../entities/DocumentChangeAuditEntity";

export class GetDocumentChangeReportSummaryUseCase {
  constructor(private readonly repository: DocumentChangeAuditRepository) {}

  execute(
    params?: DocumentChangeAuditQueryParams,
  ): Promise<DocumentChangeReportSummaryEntity> {
    return this.repository.getReportSummary(params);
  }
}
